"use strict";
import { Percent } from "@uniswap/sdk-core";
const PERCENT_PRECISION = 1e5;
export function percentFromFloat(value) {
  return new Percent(Math.round(value * PERCENT_PRECISION), PERCENT_PRECISION);
}
